import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-app-sidebar-body',
    templateUrl: './sidebar-body.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppSidebarBodyComponent {
    @HostBinding() class = 'eui-app-sidebar-body';

    constructor() {}
}
